import React from "react";
import "../../assets/css/Legal.css";

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1>Privacy Policy</h1>
            <p className="hero-subtitle">
              How Samyama collects, uses, and protects your information
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-meta">
              <p><strong>Privacy Policy for Samyama</strong></p>
              <p><strong>Operated by:</strong> VaidhyaMegha Private Limited</p>
              <p><strong>Effective Date:</strong> 1-June-2025</p>
              <p><strong>Next Update:</strong> 1-Dec-2025</p>
            </div>

            <div className="legal-section">
              <h2>1.Introduction</h2>
              <p>
              Welcome to samyama.ai, a product and property of VaidhyaMegha Private Limited (“VaidhyaMegha”, “we”, “our”, or “us”). This Privacy Policy outlines our strict commitment to the collection, use, disclosure, storage, protection, and retention of your data—with zero tolerance for misuse or leakage. We treat data privacy and user consent as fundamental rights. Our practices strictly comply with the Information Technology Act, ISO/IEC 27001, and future DPDP Act readiness.
              </p>
            </div>

            <div className="legal-section">
              <h2>2. What This Policy Covers</h2>
              <p>
              This policy applies to all data interactions via samyama.ai, including redirections from vaidhyamegha.com, user interactions, offline initiations, and communications through linked channels.
              </p>
            </div>

            <div className="legal-section">
              <h2>3. Data We Collect</h2>
              <p>
              We operate on data minimization and purpose limitation. We collect:
              </p>
              <ul>
                <li>  Personal Data: Name, contact, ID (if consented), company, etc.</li>
                <li>Technical Data: IP, browser, OS, timestamps, etc.</li>
                <li>Sensitive Data: Only if required, fully encrypted and secure.</li>
                <li>No ad trackers, behavioral profiling, or dark patterns.</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>4. Purpose of Data Collection</h2>
              <p>
              We collect and use your data only for legitimate, explicitly stated, and narrowly defined purposes. These include:
              </p>
              <p>
              Account creation and service provisioning
              </p>
              <p>To enable authentication, manage user sessions, and provide access to platform-specific services, tools, and APIs.</p>
              <p>
              Security and fraud prevention
              </p>
              <p>To protect user accounts, detect unauthorized access, monitor anomalies, and enforce security protocols.</p>
              <p>
              Compliance and regulatory support
              </p>
              <p>To meet obligations under applicable Indian and international data protection laws, health-tech guidelines, financial compliance (e.g., KYC/AML), and any court-ordered mandates.</p>
              <p>No data is used for advertising, marketing, or profiling unless you have explicitly opted in.</p>
              <p>We do not engage in behavioral advertising, third-party profiling, automated decision-making, or retargeting based on your personal data by default.</p>
            
              <div className="legal-section">
              <h2>5. Data Sharing and Disclosure</h2>
              <p>
              We do not sell, rent, trade, or disclose your personal data to any third party for commercial purposes. Data sharing occurs only under tightly controlled circumstances, and only when strictly necessary for legitimate operations, legal compliance, or service provisioning.
              </p>
              <p>Data may be shared only with the following entities:</p>
              <p>Authorized Employees of VaidhyaMegha Private Limited
                <ul>
                  <li>Access is granted strictly on a “need-to-know” basis.</li>
                  <li>All employees are bound by formal Non-Disclosure Agreements (NDAs), confidentiality clauses in employment contracts, and internal access control policies.</li>
                  <li>Regular audits are conducted to monitor and log access.</li>
                </ul>

              </p>
              <p> Trusted Third-Party Service Providers and Subprocessors
                <ul>
                  <li>These include cloud infrastructure providers, payment processors, secure email delivery systems, and compliance support tools.</li>
                  <li>Every third-party processor is contractually obligated to maintain confidentiality, implement industry-standard security, and process data only under our instructions.</li>
                  <li>We only engage vendors that are certified under standards like ISO/IEC 27001, SOC 2 Type II, or GDPR-compliant frameworks.</li>
                </ul>

              </p>
              <p>Governmental, Regulatory, or Legal Authorities
                <ul>
                  <li>Only in response to valid legal obligations such as court orders, subpoenas, regulatory mandates, or applicable law enforcement requests.</li>
                  <li>Where possible, users will be notified in advance unless prohibited by law.</li>
                </ul>
                <p>
                <b>We strictly prohibit:</b>
                </p>
                <ul>
                  <li>Sale of personal data under any circumstance</li>
                  <li>Sharing for advertising, marketing, or profiling</li>
                  <li>Unsupervised third-party analytics</li>
                </ul>
                <p>
                Each sharing instance is logged, reviewed, and periodically audited for compliance with data protection laws and internal governance.
                </p>
              </p>
            </div>

            
            <div className="legal-section">
              <h2>6. Data Storage and Security
              </h2>
              <p>
              We are committed to protecting your personal data through rigorous technical, organizational, and administrative controls. All information collected on Samyama is stored and secured in accordance with globally recognized best practices, including ISO/IEC 27001, and Indian IT Act 2000 (with 2008 amendments).
              </p>
              <p>
              Our security framework includes the following controls:
              </p>
              <p>
              Encryption Standards
              </p>
              <ul>
                <li>AES-256 encryption is applied to all data at rest, ensuring strong protection of stored information within our cloud infrastructure.</li>
                <li>All data in transit is protected using TLS 1.3 or higher, ensuring end-to-end security during communication between your browser/device and our servers.</li>
              </ul>
              <p>
              Access Management and Role Control
              </p>
              <ul>
                <li>Access to personal or sensitive data is governed by Identity and Access Management (IAM) protocols.</li>
                <li>Users, employees, and systems are assigned role-based permissions, following the principle of least privilege.</li>
                <li>All elevated access is time-bound, auditable, and requires multi-factor authentication (MFA).</li>
              </ul>
              <p>
              Perimeter and Internal Security
              </p>
              <ul>
                <li>Our servers and applications are protected using firewalls, intrusion prevention systems (IPS), and anti-DDoS protections.</li>
                <li>The infrastructure is built on a Zero Trust security architecture, meaning no implicit trust is granted to any user or system, regardless of location or network origin.</li>

              </ul>
              <p>
              Audit Trails and Monitoring
              </p>
              <ul>
                <li>Every access, configuration change, and data transaction is fully logged and monitored.</li>
                <li>Logs are securely stored for a minimum of 24 months and reviewed periodically for anomalies and unauthorized access attempts.</li>
                <li>Independent security audits and vulnerability assessments are conducted regularly by external cybersecurity firms.</li>
              </ul>
              <p>
              <b>Hosting & Data Residency</b>
              </p>
              <p>
              All data is stored on secure cloud infrastructure located within India, unless otherwise consented or mandated for cross-border regulatory interoperability.
              </p>
            </div>

            <div className="legal-section">
              <h2>7. Data Retention</h2>
              <p>
              We retain personal and system-generated data only for as long as necessary to fulfill the purposes for which it was collected, or as required by law, regulation, or contractual obligations. Data retention periods are reviewed annually, and deletion is carried out in accordance with our internal data lifecycle management policy and security protocols.
              </p>
              <p><b>Retention Periods by Data Category:</b></p>
              <ul>
                <li><b>User Account Data</b></li>
                <p>Includes names, contact information, login credentials, authentication records, and user preferences.</p>
                <p><b>Retention Period:</b> Up to <b>5 years</b> following the last recorded activity or account closure, unless an earlier deletion is requested and legally permissible.</p>
                <li><b>Health and Medical Information</b></li>
                <p>Any personal health data submitted voluntarily through AI medical assistance modules or virtual consultations.</p>

                <p><b>Retention Period: 3 years,</b> in line with healthcare data guidelines.</p>
                <p> Users may request <b>earlier deletion</b> of this data, subject to verification and absence of regulatory holds.</p>
                <li><b>System and Operational Logs</b></li>
                <p> Includes access logs, error logs, and security-related metadata.</p>
                <p><b> Retention Period: 6 months,</b> unless linked to ongoing investigations or system diagnostics.</p>
                <li><b>Financial and Transactional Records</b></li>
                <p> Covers billing information, payment history, transaction IDs, invoices, and associated metadata.</p>
                <p><b>Retention Period:</b> Up to <b>8 years</b>, to comply with Indian accounting standards, tax laws, and audit requirements.</p>
                
              </ul>
              <p><b>Deletion and Archival Protocols:</b></p>
              <ul>
                <li>All deletion operations are <b>irreversible</b> and follow secure data destruction methods such as <b>crypto-shredding</b> or <b>zero-fill overwriting</b>.</li>
                <li>Archived data (where applicable) is encrypted and access-restricted.</li>
                <li>On expiry of a retention period, data is either <b>permanently deleted</b> or <b>anonymized</b> for statistical use, with no linkage to the original identity.</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>8. User Rights and Controls</h2>
              <p>
              We recognize and uphold your fundamental rights as a data subject. In accordance with applicable privacy regulations—such as the <b>General Data Protection Regulation (GDPR)</b>, the <b>Indian IT Act</b>, and emerging frameworks like the <b>Digital Personal Data Protection (DPDP) Act</b>—you are entitled to full transparency, control, and autonomy over your personal data.
              </p>
              <p>
              <b>You have the right to:</b>
              </p>
              <ul>
                <li><b>Access Your Data</b></li>
                <p> Request a summary of all personal data we hold about you, including the purposes of processing, categories of data, and any third parties with whom it has been shared.</p>
                <li><b>Rectify Inaccurate Data</b></li>
                <p>Request correction or completion of incomplete, outdated, or inaccurate personal information maintained in our systems.</p>
                <li><b>Erase Your Data (Right to Be Forgotten)</b></li>
                <p> Request the permanent deletion of your personal data, subject to regulatory exceptions (e.g., compliance, financial records, legal claims).</p>
                <li><b>Restrict Processing</b></li>
                <p>Limit the processing of your data where accuracy is contested, or processing is unlawful but you object to deletion.</p>
                <li><b>Object to Processing</b></li>
                <p>Object to data processing based on legitimate interest, direct marketing, or profiling, even if initially consented to.</p>
                <li><b>Data Portability</b></li>
                <p> Obtain a copy of your personal data in a structured, commonly used, machine-readable format (e.g., JSON, CSV) and transfer it to another service provider upon request.</p>
              </ul>
              <p>
              <b>How to Exercise Your Rights</b>
              </p>
              <p>
              To exercise any of the above rights, please contact our Data Privacy Office:
              </p>
              <p>
              <b>Email:</b> contact@samyama.ai
              </p>
              <p>
              All requests will be acknowledged within <b>72 hours</b> and fulfilled within <b>15 working days</b>, subject to identity verification and applicable exemptions.
              </p>
              <p>
               Please note: For sensitive requests (e.g., medical data deletion), we may require multi-factor verification to prevent unauthorized access or tampering.
              </p>
            </div>
            
            <div className="legal-section">
              <h2>9. Children’s Privacy</h2>
              <p>
              The services provided by Samyama are not intended for use by individuals under the age of 16. We do not knowingly solicit, collect, or process personal data from children or minors without verifiable parental or guardian consent, in accordance with applicable laws such as:
              </p>
              <ul>
                <li>
                Section 43A of the Indian IT Act
                </li>
                <li>
                COPPA (U.S. – Children's Online Privacy Protection Act)
                </li>
                <li>
                GDPR Article 8 (EU/EEA)
                </li>
               
              </ul>
              <p>
             <b>Policy Enforcement:</b>
              </p>
              <ul>
                <li>
                If it is discovered that a child under the age of 16 has submitted personal data—<b>with or without intent</b>—we will:
                <ul>
                  <li>
                 Promptly <b>delete the data</b> from our systems;
                  </li>
                  <li>
                  Attempt to <b>notify the child’s parent or legal guardian</b>, if identifiable;
                  </li>
                  <li>
                  Prevent future submissions by that user through flagging and IP/account restrictions.
                  </li>
                </ul>
                </li>
              </ul>
              <p>
              <b>User Responsibility:</b>
              </p>
              <p>
              We encourage parents and guardians to monitor their children’s online activity and guide them in using internet platforms responsibly. If you believe your child has submitted personal information to Samyama in error, please contact us immediately at:
              </p>
              <p>
              <b>Email:</b> contact@samyama.ai
              </p>
              </div>
             
              <div className="legal-section">
              <h2>10. International Data Transfers</h2>
              <p>
              At present, all personal and sensitive data collected via<b> Samyama</b> is <b>stored and processed exclusively within data centers located in India.</b> Our infrastructure providers are bound by strict data residency requirements and comply with Indian IT security regulations and international data protection frameworks.
              </p>
              <p>
              <b>Cross-Border Transfers (If Applicable in Future)</b>
              </p>
              <p>
              If at any time in the future it becomes operationally necessary to transfer personal data outside of India—for example, to trusted subprocessors, regulatory authorities, or for interoperability with global services—<b>we will ensure such transfers are handled with the highest level of legal and technical safeguards,</b> including:
              </p>
              <ul>
                <li>
                <b>GDPR-Compliant Transfer Mechanisms</b>
                <p>All international data transfers will be governed by:</p>
                <ul>
                  <li>
                  <b>Standard Contractual Clauses (SCCs)</b> approved by the European Commission;
                  </li>
                  <li>
                  Adequacy decisions (where applicable);
                  </li>
                  <li>
                  Binding Corporate Rules (BCRs) for our group entities (if structured).
                  </li>
                </ul>
                </li>
              </ul>
              <ul>
                <li>
                <b>Contractual and Technical Protections</b>
                <p>Third-country recipients will be subject to:</p>
                <ul>
                  <li>
                  Enforceable contractual obligations on data protection;
                  </li>
                  <li>
                  Independent audits;
                  </li>
                  <li>
                  Encryption and access control requirements;
                  </li>
                  <li>
                  Non-disclosure agreements and limited data usage rights.
                  </li>
                </ul>
                </li>
              </ul> 
              <ul>
                <li>
                <b>Transparency and User Notification</b>
                </li>
                <p> We will <b>notify affected users</b> before initiating any cross-border transfer involving their personal data and offer options to opt out where feasible.</p>
              </ul>
            <p>
              <b>No Transfers Without Legal Basis</b>
            </p> 
            <p>
            We will never transfer your personal data outside India <b>without a lawful basis</b>, nor without ensuring it receives an <b>equivalent or higher level of protection</b> as required by Indian and international privacy laws.
            </p> 
            </div>

            <div className="legal-section">
              <h2>11. Policy Updates</h2>
              <p>
              We reserve the right to modify or update this Privacy Policy periodically to reflect changes in:
              </p>
              <ul>
                <li>
                Legal or regulatory requirements (e.g., new data protection laws);
                </li>
                <li>
                Our internal data handling practices;
                </li>
                <li>
                The scope of services offered on Samyama;
                </li>
                <li>
                Technological advancements or security enhancements.
                </li>
              </ul>
              <p><b>How We Notify You</b> </p>
              <p>
              To ensure transparency, we will provide advance notice of any material changes:
              </p>
              <ul>
                <li>
                Notification Timeline: At least 15 calendar days prior to the effective date of the updated policy.
                </li>
                <li>
                Notification Channels:
                <ul>
                  <li>
                  A prominent announcement banner or modal on the samyama.ai website;
                  </li>
                  <li>
                  Direct email communication to registered users (if applicable).
                  </li>
                </ul>
                </li>
              </ul>
              <p>
              <b>User Acknowledgment</b> 
              </p>
              <ul>
                <li>
                Continued use of the Samyama platform after the effective date of the revised policy shall constitute your acceptance of the updated terms.
                </li>
                <li>
                If you do not agree with the changes, you have the right to request account deletion or contact our privacy team with any concerns before the changes take effect.
                </li>
              </ul>
            </div> 
            
            <div className="legal-section">
              <h2>12. Data Breach Notification</h2>
              <p>
              At Samyama, we implement stringent security measures to prevent unauthorized access, misuse, or compromise of personal data. However, in the rare event of a personal data breach (as defined under applicable law), we follow a clear, time-bound incident response protocol to protect your rights and comply with regulatory mandates.
              </p>
              <p>
              Our Notification Policy Includes:
              </p>
              <ul>
                <li>
                <b>User Notification Timeline</b>
                <p> We will notify affected users within 72 hours of becoming aware of a confirmed data breach involving personal or sensitive data, unless prohibited by law or ongoing forensic investigation.</p>
                </li>
                <li>
                <b>Notification Method</b>
                <ul>
                  <li>
                  Email alerts (to the registered contact information);
                  </li>
                  <li>
                  Website banners or in-app notices (if applicable);
                  </li>
                  <li>
                  Any additional method required by law.
                  </li>
                </ul> 
                </li>
                <li>
                <b>Content of Notification</b>
                <p>  The notice will include:</p>
                <ul>
                  <li>
                  Nature and scope of the breach;
                  </li>
                  <li>
                  Categories of affected data;
                  </li>
                  <li>
                  Likely consequences or risks;
                  </li>
                  <li>
                  Remedial actions taken;
                  </li>
                  <li>
                  Contact details for further queries or support.
                  </li>
                </ul> 
                </li>
              </ul>
             <p><b>Regulatory Reporting:</b></p>
             <ul>
              <li>
              In accordance with Indian IT security regulations, we will notify the Indian Computer Emergency Response Team (CERT-In) within the legally mandated timeframe.
              </li>
              <li>
              Where the breach affects users from other jurisdictions (e.g., EU/UK), we will notify the relevant Data Protection Authorities (DPAs) in line with GDPR Article 33/34.
              </li>
             </ul> 
             <p><b>Remediation and Accountability:</b></p>
             <ul>
              <li>
              Affected systems will be immediately quarantined, patched, or rebuilt.
              </li>
              <li>
              Incident root cause analysis and forensic review will be documented.
              </li>
              <li>
              A post-incident impact report will be maintained and auditable for up to 2 years.
              </li>
             </ul> 
            </div> 

            <div className="legal-section">
              <h2>13. Contact & Complaints</h2>
              <p>
              We are committed to resolving your concerns regarding the collection, use, or protection of your personal data with fairness and transparency. If you have questions, complaints, or wish to exercise your data rights, please contact us through the channels below:
              </p>
              <p><b>Primary Contact</b></p>
              <p><b>VaidhyaMegha Private Limited</b></p>
              <p><b>Email:</b> enquiry@samyama.ai</p>
              <p><b>Phone:</b> +91 9618986039</p>
              <p><b>Data Protection Officer (DPO)</b></p>
              <p>You may also escalate privacy matters directly to our appointed Data Protection Officer.</p>
              <p> Please mention "Privacy Concern – Samyama" in the subject line of your email.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
